import { DistAngleToolsComponent } from 'src/app/components/attribute-view/dist-angle-tools/dist-angle-tools.component';
import { MapComponent } from '../../components/map/map.component';
import { ActionMap } from '../../services/action-handler.service';
import { SLVApp } from '../../types/@types/sl-v-types';
import { SLContext } from '../../types/sl-context';

export class DistAngleActions {
  private static app: SLVApp;
  public static components:any = {};
  public static SetApp(app) {
    DistAngleActions.app = app;
  }
  public static Exec(command: string, map: MapComponent, data: any) {
    const commandParts = command.split('-');
    let exec = '';
    commandParts.every((val) => {
      exec += val[0].toUpperCase() + val.substring(1).toLowerCase();
      return true;
    })
    if (DistAngleActions[exec]) {
      DistAngleActions[exec](map, data[0]);
    }
  }
  public static RegisterComponent(name: string, component: any) {
    DistAngleActions.components[name] = component;
  }
  public static GetDistAngleComponent():undefined | DistAngleToolsComponent {
    if(!DistAngleActions.components['dist-angle']) return undefined;
    return DistAngleActions.components['dist-angle'];
  }
  public static SetDistAngleTool(tool:string,isOn:boolean) {
    DistAngleActions.GetDistAngleComponent()?.SetTool(tool,isOn);
  }
  public static RegisterActions(actions: ActionMap): ActionMap {
    actions['dist-angle-actions/distance-angle-tools'] = {
      name: 'Distance & Angle Tools',
      handler: (context: SLContext, ...args: any) => {
        DistAngleActions.Exec('distance-angle-tools', context.map.component, args);
      }
    }
    actions['dist-angle-actions/dist-angles-sel-vertex'] = {
      name: 'Move selected vertex by distance and angle',
      handler: (context: SLContext, ...args: any) => {
        DistAngleActions.Exec('dist-angles-sel-vertex', context.map.component, args);
      }
    }
    actions['dist-angle-actions/dist-angles-add-vertex'] = {
      name: 'Add vertex at distance and angle',
      handler: (context: SLContext, ...args: any) => {
        DistAngleActions.Exec('dist-angles-add-vertex', context.map.component, args);
      }
    }
    actions['dist-angle-actions/dist-angles-add-rel-snap'] = {
      name: 'Add vertex at distance and angle from snap geometry',
      handler: (context: SLContext, ...args: any) => {
        DistAngleActions.Exec('dist-angles-add-rel-snap', context.map.component, args);
      }
    }
    return actions;
  }
  public static DistAnglesSelVertex(_map, data) {
    const params = data[0];
    const isOn = !!data[0]?.toggled;
    DistAngleActions.SetDistAngleTool('dist-angles-sel-vertex',isOn)
  }
  public static DistAnglesAddVertex(_map, data) {
    const params = data[0];
    const isOn = !!data[0]?.toggled;
    DistAngleActions.SetDistAngleTool('dist-angles-add-vertex',isOn)
  }
  public static DistAnglesAddRelSnap(_map, data) {
    const params = data[0];
    const isOn = !!data[0]?.toggled;
    DistAngleActions.SetDistAngleTool('dist-angles-add-rel-snap',isOn)
  }

}
